module.exports = __webpack_public_path__ + "static/img/Pitch_Contest_Icon.671bc82c.png";